/**
 * @fileoverview Configuration for Google Ad slots.
 * @description This file only used for GoogleAd component.
 */

import { useCustomParams } from "@src/app/hooks/useCustomParams";

const PREFIX = "/5908/thinkchina";

export const mapAdSlotId = (type: GoogleAdTypeEnum) => {
  return `dfp-ad-${type}`;
};

/**
 * @tutorial https://docs.google.com/spreadsheets/d/1OXX1gA_vR67ZQFRymdE5eWmyFWd21cXKIpkqvQShanM/edit?gid=1306078004#gid=1306078004
 */
export const adSlotSizes: Record<GoogleAdTypeEnum, googletag.GeneralSize> = {
  lb1: [
    [970, 90],
    [728, 90],
    [970, 250],
    [320, 50],
    [320, 100],
    [320, 250],
    ["fluid"],
  ],
  imu1: [[300, 250], [1, 1], ["fluid"]],
  imu2: [[300, 250], [1, 1], ["fluid"]],
  midarticlespecial: [[300, 250], [1, 1], ["fluid"]],
  catfish: [[1, 1]],
};

export const adSizeMappings: Partial<
  Record<GoogleAdTypeEnum, googletag.SizeMappingArray>
> = {
  lb1: [
    [
      [1024, 0],
      [[970, 90], [728, 90], [970, 250], "fluid"],
    ],
    [
      [740, 0],
      [[728, 90], "fluid"],
    ],
    [
      [320, 0],
      [[320, 50], [320, 100], [320, 250], "fluid"],
    ],
    [
      [0, 0],
      [[320, 50], [320, 100], [320, 250], "fluid"],
    ],
  ],
};

export const adTargetings: Partial<
  Record<GoogleAdTypeEnum, { key: string; value: string }[]>
> = {
  lb1: [
    { key: "pos", value: "1" },
    { key: "weight", value: "1" },
  ],
  imu1: [
    { key: "pos", value: "1" },
    { key: "weight", value: "5" },
  ],
  imu2: [
    { key: "pos", value: "2" },
    { key: "weight", value: "6" },
  ],
  midarticlespecial: [
    { key: "pos", value: "midarticlespecial" },
    { key: "weight", value: "4" },
  ],
  catfish: [
    { key: "pos", value: "catfish" },
    { key: "weight", value: "3" },
  ],
};

/**
 * @see https://docs.google.com/spreadsheets/d/1OXX1gA_vR67ZQFRymdE5eWmyFWd21cXKIpkqvQShanM/edit?gid=510592385#gid=510592385
 */
const adUnitPathMap: Record<GoogleAdTypeEnum, (section: string) => string> = {
  lb1: (i) => `${PREFIX}/lb1/${i}`,
  imu1: (i) => `${PREFIX}/imu1/${i}`,
  imu2: (i) => `${PREFIX}/imu2/${i}`,
  midarticlespecial: (i) => (i ? `${PREFIX}/midarticlespecial/${i}` : ""),
  catfish: (i) => `${PREFIX}/catfish/${i}`,

  // test ads
  // lb1: () => "/5908/ZB_SG/lb1/homepage",
  // imu1: () => "/5908/ZB_SG/imu1/realtime/singapore",
  // imu2: () => "/5908/ZB_SG/imu2/realtime/singapore",
  // midarticlespecial: () => "/5908/ZB_SG/midarticlespecial/realtime/singapore",
  // midarticlespecial: (i) => "/5908/redants/midarticlespecial/overview", // redants
  // catfish: () => "/5908/ZB_SG/catfish/homepage",
};

export function useComposedAdUnitPath(type: GoogleAdTypeEnum): string {
  const { level1 } = useCustomParams();
  return adUnitPathMap[type](
    // N/A for midarticlespecial in homepage
    !level1 ? (type == GoogleAdTypeEnum.MIDARTICLE ? "" : "homepage") : level1,
  );
}

export enum GoogleAdTypeEnum {
  LB1 = "lb1",
  IMU1 = "imu1",
  IMU2 = "imu2",
  MIDARTICLE = "midarticlespecial",
  CATFISH = "catfish",
  // prestitial/postitial mv to prestitial-postitial-ad.js
}
